'use strict'

Object.defineProperty(exports, '__esModule', {
  value: true
})

var _extends =
  Object.assign ||
  function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i]
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key]
        }
      }
    }
    return target
  }

var _templateObject = _taggedTemplateLiteral(
  [
    '\n  text-align: left;\n  svg {\n    flex-shrink: 0;\n  }\n  ',
    ' {\n    align-items: center;\n    flex-direction: column;\n    max-width: 20rem;\n    text-align: center;\n  }\n'
  ],
  [
    '\n  text-align: left;\n  svg {\n    flex-shrink: 0;\n  }\n  ',
    ' {\n    align-items: center;\n    flex-direction: column;\n    max-width: 20rem;\n    text-align: center;\n  }\n'
  ]
)

var _react = require('react')

var _react2 = _interopRequireDefault(_react)

var _Flex = require('./Flex')

var _Flex2 = _interopRequireDefault(_Flex)

var _Icon = require('./Icon')

var _Icon2 = _interopRequireDefault(_Icon)

var _Heading = require('./Heading')

var _Heading2 = _interopRequireDefault(_Heading)

var _Text = require('./Text')

var _Text2 = _interopRequireDefault(_Text)

var _propTypes = require('prop-types')

var _propTypes2 = _interopRequireDefault(_propTypes)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

function _objectWithoutProperties(obj, keys) {
  var target = {}
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue
    target[i] = obj[i]
  }
  return target
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(
    Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })
  )
}

var ModuleBase = _Flex2.default.extend(_templateObject, function(props) {
  return props.theme.mediaQueries.md
})

var Module = function Module(_ref) {
  var icon = _ref.icon,
    heading = _ref.heading,
    body = _ref.body,
    color = _ref.color,
    props = _objectWithoutProperties(_ref, ['icon', 'heading', 'body', 'color'])

  return _react2.default.createElement(
    ModuleBase,
    _extends({ color: color }, props),
    _react2.default.createElement(_Icon2.default, {
      size: 3 * 16,
      mr: [2, null, 0],
      mb: 1,
      name: icon,
      color: color
    }),
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_Heading2.default.h2, {
        mb: 1,
        fontSize: 3,
        children: heading
      }),
      _react2.default.createElement(_Text2.default, {
        m: 0,
        fontSize: 2,
        children: body
      })
    )
  )
}

Module.displayName = 'Module'

Module.propTypes = {
  heading: _propTypes2.default.string.isRequired,
  body: _propTypes2.default.string,
  icon: _propTypes2.default.string.isRequired
}

Module.defaultProps = {
  color: 'white',
  p: 2,
  w: [1, 1 / 3]
}

exports.default = Module



//////////////////
// WEBPACK FOOTER
// ./~/@hackclub/design-system/dist/Module.js
// module id = 179
// module chunks = 168707334958949